import { Drawer, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import * as React from "react";
import { FC } from "react";
import { ListProps, useRefresh } from "react-admin";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../../Constants/Constant";
import { GetCarrierType } from "../../../../Enums/CarrierType";
import { RemarkTypes } from "../../../../Enums/RemarkTypes";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { ExcelExport } from "../../../../Helper/ExportExcel";
import { CustomsClearanceListTitle, SourceRequestOrder } from "../Constant/Source";
import RequestOrderFileDetail from "../RequestOrderFileDetail";
import RequestOrderNotes from "../RequestOrderNotes";
import { CustomClearanceFilter } from "./CustomClearanceFilter";
import CustomClearanceOrdinoDateDialog from "./CustomClearanceOrdinoDateDialog";
import { TabbedDatagrid } from "./TabbedDataGrid";
import { useVerifyPermission } from "@airborne/react-admin";
import PoolList from "../../../../Components/PoolListComponent/PoolListComponent";

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    width: "20%",
  },
}));

const CustomsClearanceList: FC<ListProps> = props => {
  useVerifyPermission("customroutes", "customsclearance.read");
  const classes = useStyles();
  const refresh = useRefresh();
  const [isMatchCreate, setIsMatchCreate] = React.useState(false);
  const [isOrdinoDateOpen, setIsOrdinoDateOpen] = React.useState(false);
  const [isMatchShow, setIsMatchShow] = React.useState(false);
  const [requestRemark, setRequestRemark] = React.useState<any>({});
  const [requestOrder, setRequestOrder] = React.useState<any>({});
  const ExportToExcel = data => {
    ExcelExport(
      [
        {
          header: "Status",
          key: "Status",
        },
        {
          header: "Ref No",
          key: "Ref No",
        },
        {
          header: "Customer Po",
          key: "Customer Po",
        },
        {
          header: "Requested Delivery Date",
          key: "Requested Delivery Date",
        },
        {
          header: "Pn",
          key: "Pn",
        },
        {
          header: "Core Unit Sn",
          key: "Core Unit Sn",
        },
        {
          header: "Core Unit AWB",
          key: "Core Unit AWB",
        },
        {
          header: "Core Unit Forwarding Agency",
          key: "Core Unit Forwarding Agency",
        },
        {
          header: "Ordino Date",
          key: "Ordino Date",
        },
        {
          header: "Arrival Date",
          key: "Arrival Date",
        },
      ],
      data.map(v => [
        v.requestStatus,
        v.refNo,
        v.customerPo,
        v.requestedDeliveryDate != null ? v.requestedDeliveryDate : "",
        v.customerRequestComponent,
        v.unserviceable?.sn,
        v.unserviceable?.awb,
        GetCarrierType.find(x => x.Value == v.unserviceable?.carrierEnum)?.Description,
        v.unserviceable?.ordinoDate != null ? v.unserviceable?.ordinoDate : "",
        v.arrivalDate != null ? v.arrivalDate : "",
      ]),
      "Custom Clearance List"
    );
  };
  const allMatchClosed = () => {
    setIsMatchCreate(false);
    setIsMatchShow(false);
  };
  const remarkAddClick = record => {
    allMatchClosed();
    setIsMatchCreate(true);
    setRequestRemark(record);
  };
  const ordinoDateAddClick = record => {
    allMatchClosed();
    setIsOrdinoDateOpen(true);
    setRequestOrder(record);
  };
  const fileDetailShowClick = record => {
    allMatchClosed();
    setIsMatchShow(true);
    setRequestOrder(record);
  };
  const handleClose = () => {
    setIsMatchCreate(false);
  };
  const handleCloseOrdinoDate = () => {
    refresh();
    setIsOrdinoDateOpen(false);
  };
  const handleFileDetailClose = () => {
    setIsMatchShow(false);
  };
  return (
    <Grid container>
      <Grid item xs={isMatchCreate ? 9 : 12}>
        <PoolList
          {...props}
          hasCreate={false}
          bulkActionButtons={false}
          resource={SourceRequestOrder}
          basePath={SourceRequestOrder}
          title={CustomsClearanceListTitle}
          exporter={ExportToExcel}
          filterDefaultValues={{
            requestStatus__eq: RequestStatus.PlaneLanded,
            isUnsvcInfo__eq: true,
          }}
          sort={DefaultCreatedDateSort}
          perPage={DefaultPerPageSize}
          filters={<CustomClearanceFilter />}
        >
          <TabbedDatagrid
            remarkAddClick={remarkAddClick}
            ordinoDateAddClick={ordinoDateAddClick}
            fileDetailShowClick={fileDetailShowClick}
          />
        </PoolList>
      </Grid>
      {isMatchCreate && (
        <Grid item xs={3}>
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="persistent"
            open={isMatchCreate}
            anchor="right"
            onClose={handleClose}
          >
            {isMatchCreate ? (
              <RequestOrderNotes
                onCancel={handleClose}
                request={requestRemark}
                resource="requestremarks"
                basePath="requestremarks"
                remarkType={RemarkTypes.PbhNote}
              />
            ) : null}
          </Drawer>
        </Grid>
      )}
      <Grid>
        {isMatchShow && (
          <RequestOrderFileDetail open={isMatchShow} requestOrder={requestOrder} handleClose={handleFileDetailClose} />
        )}
      </Grid>
      <CustomClearanceOrdinoDateDialog
        record={requestOrder}
        open={isOrdinoDateOpen}
        handleClose={handleCloseOrdinoDate}
      />
    </Grid>
  );
};

export default CustomsClearanceList;
